export const YoutubeIcon = () => {
  return (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2879 14.3767L7.22568 14.3007C5.91044 14.2743 4.59191 14.3271 3.30246 14.053C1.34089 13.6435 1.20193 11.6356 1.05652 9.95135C0.856153 7.58351 0.933719 5.17269 1.31183 2.82461C1.52528 1.5071 2.36532 0.720927 3.6644 0.635376C8.04975 0.324901 12.4643 0.361696 16.8399 0.506544C17.302 0.519822 17.7673 0.592398 18.223 0.675009C20.4723 1.07793 20.5271 3.35332 20.673 5.26878C20.8184 7.204 20.757 9.14916 20.479 11.0712C20.2561 12.6626 19.8295 13.9972 18.0291 14.126C15.7733 14.2944 13.5693 14.4301 11.3072 14.3869C11.3073 14.3767 11.2943 14.3767 11.2879 14.3767ZM8.8997 10.3477C10.5996 9.35026 12.2671 8.36948 13.9573 7.37875C12.2542 6.38134 10.5899 5.40055 8.8997 4.40983V10.3477Z"
        fill="white"
      />
    </svg>
  );
};
